import React from 'react';
import { IconProps } from './types';

const BundleIcon: React.FC<IconProps> = ({ className, fill }) => (
  <svg className={className} xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill={fill}>
    <path d="M2.66719 13.3341V4.73411L1.36719 1.90077L2.56719 1.33411L4.13385 4.70077H11.8672L13.4339 1.33411L14.6339 1.90077L13.3339 4.73411V13.3341H2.66719ZM6.66719 8.66744H9.33385C9.52274 8.66744 9.68108 8.60355 9.80885 8.47577C9.93663 8.348 10.0005 8.18966 10.0005 8.00077C10.0005 7.81188 9.93663 7.65355 9.80885 7.52577C9.68108 7.398 9.52274 7.33411 9.33385 7.33411H6.66719C6.4783 7.33411 6.31996 7.398 6.19219 7.52577C6.06441 7.65355 6.00052 7.81188 6.00052 8.00077C6.00052 8.18966 6.06441 8.348 6.19219 8.47577C6.31996 8.60355 6.4783 8.66744 6.66719 8.66744Z" />
  </svg>
);

export default BundleIcon;
